import { Action, combineReducers } from "@reduxjs/toolkit";

import { orders, archiveOrderAction, StateOrders } from "./Orders";
import { State as StateGPS } from "./GPSLog/interface";
import { archiveGPSLogAction, archiveGPSLogReducer } from "./GPSLog";
import {
	StateTransactions,
	transactions,
	archivesTransactionsAction,
} from "./Transactions";
import {
	StateBankTransactions,
	bankTransactions,
	archivesBankTransactionsAction,
} from "./BankTransactions";
import {
	StateMessagesHistory,
	messagesHistory,
	archivesMessagesHistoryAction,
} from "./MessagesHistory";
import {
	StatePushHistory,
	pushHistory,
	archivesPushHistoryAction,
} from "./PushHistory";
import { Archive } from "./interface";

export { Archive };

export type State = {
	orders: StateOrders;
	gps: StateGPS;
	transactions: StateTransactions;
	bankTransactions: StateBankTransactions;
	messagesHistory: StateMessagesHistory;
	pushHistory: StatePushHistory;
};

export type Actions = {
	orders: typeof archiveOrderAction;
	gps: typeof archiveGPSLogAction;
	transactions: typeof archivesTransactionsAction;
	bankTransactions: typeof archivesBankTransactionsAction;
	messagesHistory: typeof archivesMessagesHistoryAction;
	pushHistory: typeof archivesPushHistoryAction;
};

export const archiveReducer = combineReducers<State, Action<Actions>>({
	orders,
	gps: archiveGPSLogReducer,
	transactions,
	bankTransactions,
	messagesHistory,
	pushHistory,
});

export const archiveAction: Actions = {
	orders: archiveOrderAction,
	gps: archiveGPSLogAction,
	transactions: archivesTransactionsAction,
	bankTransactions: archivesBankTransactionsAction,
	messagesHistory: archivesMessagesHistoryAction,
	pushHistory: archivesPushHistoryAction,
};

export default archiveReducer;
